import { render } from "./RegistrationListItemCheckbox.vue?vue&type=template&id=19e7a2d9&ts=true"
import script from "./RegistrationListItemCheckbox.vue?vue&type=script&lang=ts"
export * from "./RegistrationListItemCheckbox.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/maqqie/maqqie-client-portal/clientportal-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__